// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__dK9Ey","buttons":"RemoveExpirationActionButtons_buttons__3c9Jf"};